/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Interrupt_PromptInputs */

const es_chat_interrupt_prompt = /** @type {(inputs: Chat_Interrupt_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presiona Enter de nuevo para interrumpir`)
};

const en_chat_interrupt_prompt = /** @type {(inputs: Chat_Interrupt_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press Enter again to interrupt`)
};

/**
* | output |
* | --- |
* | "Press Enter again to interrupt" |
*
* @param {Chat_Interrupt_PromptInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_interrupt_prompt = /** @type {((inputs?: Chat_Interrupt_PromptInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Interrupt_PromptInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_interrupt_prompt(inputs)
	return en_chat_interrupt_prompt(inputs)
});
export { chat_interrupt_prompt as "chat.interrupt_prompt" }